import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import jsPDF, { jsPDFOptions } from 'jspdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

import domToImage from 'dom-to-image';
import moment from 'moment';

@Component({
  selector: 'app-pay-book',
  templateUrl: './pay-book.component.html',
  styleUrls: ['./pay-book.component.scss']
})
export class PayBookComponent implements OnInit {

  payments: any;
  contractId:any;
  payExpDays = 15;

  pages:any;
  pdf:any;
  contract:any;

  Arr = Array;
  // @ViewChild('paySlip', { static: false }) public paySlip: ElementRef;
  @ViewChildren('paySlip', { read: ViewContainerRef }) public paySlip: QueryList<ViewContainerRef>;


  constructor(private authService: AuthenticationService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.contractId = this.route.snapshot.paramMap.get("id");
    this.getContract(this.contractId);
  }

  getContract(id:any){

    this.authService.getContract(id).then((res:any)=>{
        console.log(res);
        this.contract =res;
        // let data = res.find((x:any) => x.id == id);
        // this.solicitante = JSON.parse(data.solicitante)
        // console.log(this.solicitante);
        let balance = res.qTotalPayment;
        this.payments = res.contractInstallments;
        // this.amortization = JSON.parse(data.amortization);
        this.payments = this.payments.map((x:any) => {
          let date = new Date(x.installmentDate);
          date.setDate(date.getDate() + this.payExpDays);
          x.expDate = date;
          x.recargo = x.installmentAmount * .05;
          x.recargoPaymentAmount = x.installmentAmount + x.recargo;
          balance -= x.installmentAmount
          balance = balance > 0 ?  balance : 0;
          x.thisEndingBalance = balance;
          
          return x;
        })

        console.log(this.payments);

        let i = 1;
        let pages:any = [];
        let pages2:any = []
        for(let payment of this.payments){
          console.log(i%4);
          pages.push(payment);
          if(i%4 == 0){
            pages2.push({slips: pages});
            pages= [];
          }
          i++;
        }

        if(pages2.length > 0){
          this.pages = pages2;
        }else{
          pages2.push({slips: pages});
          this.pages = pages2;
        }

        

        // console.log(this.amortization);
        this.setPDF();
      })
  }

  setPDF(){
    let orientation = 'p';
    let imageUnit = 'pt';
    let jsPdfOptions:any = {
      orientation: orientation,
      unit: imageUnit,
      format: [2750, 2150]
      };
    this.pdf = new jsPDF(jsPdfOptions);
    this.pdf.setFontSize(28);
    this.pdf.setTextColor('#2585fe');
    this.pdf.text('Contrato# ' + this.contractId ? 'contrato#' + this.contractId.toUpperCase() : 'Untitled dashboard'.toUpperCase(), 25, 75);
    this.pdf.setFontSize(24);
    this.pdf.setTextColor('#131523');
    this.pdf.text('Generated Date: ' + moment().format('ll'), 25, 115);
    
  }
  
  async downloadAsPDF(){
    let i = 0;
    this.paySlip.map(async (x:any)=>{
      console.log(x);
      x = x.element;
      const width = x.nativeElement.clientWidth + 1500;
      const height = x.nativeElement.clientHeight + 1500;
      domToImage.toPng(x.nativeElement, {
        // quality: 0.99,
        width: width,
        height: height,
        style: {
          transform: 'scale(2)',
          transformOrigin: 'top left'
        }
      }).then(result => {
        this.pdf.addImage(result, 'PNG', 25, 185, width, height, 'FAST');
        i++;
        if(i < this.pages.length){
          this.pdf.addPage();
        } else{
          this.pdf.save(this.contractId+'-pay'+ '.pdf');
        }
        
        })
        .catch(error => {
        });
    })
    
  }


  exportAllToPDF(pages: HTMLElement) {
    // console.log(pages);
    // const doc = new jsPDF();
    let options: jsPDFOptions = {
      orientation: 'p',
      unit: 'cm',
      format: [100,400]
      
      
    }
    const doc = new jsPDF();

    doc.html(pages, {
      callback: (doc: jsPDF) => {
        doc.deletePage(doc.getNumberOfPages());
        doc.save(this.contractId+'-paySlips.pdf');
      }
    });
  }

  


}
